import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class IntelligenceLeads extends Http {
  [x: string]: any
  public async getIntelligenceCluesTitle(data: NLoginApi.getIntelligenceCluesTitleRequestData) {
    return await super.request<NLoginApi.getIntelligenceCluesTitleResponse>({
      url: '/crossbowSystem/getIntelligenceCluesTitle',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getIntelligenceClues(data: NLoginApi.getIntelligenceCluesRequestData) {
    return await super.request<NLoginApi.getIntelligenceCluesResponse>({
      url: '/crossbowSystem/getIntelligenceClues',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getCollectionArticle(data: NLoginApi.getCollectionArticleRequestData) {
    return await super.request<NLoginApi.getCollectionArticleResponse>({
      url: '/crossbowSystem/isCollectionArticle',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default IntelligenceLeads
